import { Link, Link as RouterLink } from 'react-router-dom';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  CardActions,
  Button,
  Typography
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import AddchartIcon from '@material-ui/icons/Addchart';
import helper from 'src/utils/helpers';




const TotalCustomers = ({data}) => {






return(
  <Card
  sx={{ height: '200px' }}
  >

    <CardContent>
      <Grid
        container
        spacing={1}
      >
        <Grid item className="flex-grow-1">
        <Typography
              color="primary"
              variant="h6"
            >
         AVAILALBLE CREDIT
            </Typography>
            <Box sx={{
                   m: 1,   
                   alignItems: 'center'
              }}>
                    <Typography
              color="textSecondary"
              variant="caption"
            >
              Maximum Credit
            </Typography>
              <Typography
              sx={{
                mr: 1
              }}
              color="textPrimary"
              variant="h5"
            >
             {helper.toCurrency(data && data.maxAmount)}
            </Typography>
          
              </Box>
              <Box sx={{
                   m: 1,   
                   alignItems: 'center'
              }}>
                    <Typography
              color="textSecondary"
              variant="caption"
            >
                Rate
            </Typography>
              <Typography
              sx={{
                mr: 1
              }}
              color="textPrimary"
              variant="h5"
            >
              {data && data.weeklyRate * 100} %
            </Typography>
          
              </Box>
          </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: green[600],
              height: 56,
              width: 56
            }}
          >
            <AddchartIcon />
          </Avatar>
        </Grid>
      </Grid>
    </CardContent>
    <CardActions className="center-element">
        <Button size="small"
        component={RouterLink}
        to="/app/applications"
        >APPLY</Button>
      </CardActions>
  </Card>
);
}
export default TotalCustomers;
